import { createAction } from '@reduxjs/toolkit';

export const clearState = createAction('app/clear');
